import { useContext } from 'react';

import LipidRawMaterialContext from '../../context/materialcapture/LipidRawMaterialContext';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Autocomplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';

import MaterialDivider from './MaterialDivider';

const LipidAliquotForm = ({ index, data }) => {
  const { 
    initialValues, formErrors, handleAliquotInputChange, handleAliquotDelete 
  } = useContext(LipidRawMaterialContext);

  return(
    <Grid container spacing={1} sx={{ mt: 2}}>
      <MaterialDivider 
        title={'Lipid Aliquot'} 
        index={index} 
        showDeleteIcon={!data?.in_use}
        handleDelete={handleAliquotDelete}
        deleteIndex={data?.index} 
        deleteId={data?.id} 
        showChip={data?.in_use} 
      />
      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Unique aliquot ID *"
          name={`unique_aliquot_id-${data?.index}`}
          value={data?.unique_aliquot_id}
          onChange={e => 
            handleAliquotInputChange(e, data?.index, 'unique_aliquot_id', e.target.value)
          }
          helperText={formErrors[`unique_aliquot_id-${data?.index}`]}
          error={`unique_aliquot_id-${data?.index}` in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <FormControl fullWidth>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label='Date aliquoted *'
              name={`date_aliquoted-${data?.index}`}
              value={data?.date_aliquoted} 
              onChange={e => 
                handleAliquotInputChange(e, data?.index, 'date_aliquoted', e)
              } 
              maxDate={initialValues?.today}
              renderInput={(params) => 
                <TextField 
                  {...params} 
                  error={Boolean(formErrors[`date_aliquoted-${data?.index}`])}
                  helperText={formErrors[`date_aliquoted-${data?.index}`]}
                />
              }
            />
          </LocalizationProvider>
        </FormControl>
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          multiple
          freeSolo
          fullWidth
          value={data?.aliquot_operator_list || []}
          options={initialValues?.operatorArray || []}
          onChange={(e, newValue) => {
            handleAliquotInputChange(
              e, data?.index, "aliquot_operator_list", newValue
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Operator *"
              placeholder="Type to search Operator..."
              error={`aliquot_operator_list-${data?.index}` in formErrors}
              helperText={
                formErrors[`aliquot_operator_list-${data?.index}`]
              }
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default LipidAliquotForm;